import { computed } from 'vue';
import { useRouter } from 'vue-router';
import { useApi } from './useApi';
import { useAuthStore } from '../stores/auth';

export function useAuth() {
  const router = useRouter();
  const api = useApi();
  const authStore = useAuthStore();
  const user = computed(() => authStore.user);

  const login = async (credentials) => {
    return await authStore.login(credentials.email, credentials.password);
  };

  const logout = () => {
    authStore.logout();
    router.push('/auth/login');
  };

  const checkAuth = async () => {
    return await authStore.initialize();
  };

  const hasRole = (roles) => {
    if (!user.value) return false;
    if (Array.isArray(roles)) {
      return roles.includes(user.value.role);
    }
    return user.value.role === roles;
  };

  const hasPermission = (permission) => {
    if (!user.value || !user.value.permissions) return false;
    return user.value.permissions.includes(permission);
  };

  const hasAnyPermission = (permissions) => {
    if (!user.value || !user.value.permissions) return false;
    return permissions.some(permission => user.value.permissions.includes(permission));
  };

  const hasAllPermissions = (permissions) => {
    if (!user.value || !user.value.permissions) return false;
    return permissions.every(permission => user.value.permissions.includes(permission));
  };

  return {
    user,
    login,
    logout,
    checkAuth,
    hasRole,
    hasPermission,
    hasAnyPermission,
    hasAllPermissions
  };
} 